import { Navigate } from 'react-router-dom';
import { User } from '../models/User';

interface ProtectedRouteProps {
  user: User | null;
  requiredRole?: string;
  children: React.ReactNode;
}

export default function ProtectedRoute({ user, requiredRole, children }: ProtectedRouteProps) {
  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (requiredRole && user.userRole.toLowerCase() !== requiredRole.toLowerCase()) {
    return <Navigate to="/" replace />;  // or a /unauthorized page
  }

  return <>{children}</>;
}